import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const CategoryPage = () => {
  const navigate = useNavigate();
  const { menAndWomenCategory } = useSelector((store) => store.category);
  const { subCategorytotal } = useSelector((store) => store.subCategory);

  const navigationClick = (category) => {
    if (category) {
      const getSubCategory = subCategorytotal?.find(
        (subcat) => subcat.categoryId === category._id
      );

      if (getSubCategory) {
        // ✅ CRITICAL: Pass category data in state
        navigate(`/${category.slugUrl}/${getSubCategory.name}`, { 
          state: category 
        });
      } else {
        // Fallback without subcategory
        navigate(`/${category.slugUrl}`, { 
          state: category 
        });
      }
    }
  };

  // Check if data is available
  if (!menAndWomenCategory || !Array.isArray(menAndWomenCategory)) {
    return (
      <div className="pt-4" style={{ backgroundColor: "#f5f6fb" }}>
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2 text-muted">Loading categories...</p>
        </div>
      </div>
    );
  }

  // Check if array is empty
  if (menAndWomenCategory.length === 0) {
    return (
      <div className="pt-4" style={{ backgroundColor: "#f5f6fb" }}>
        <div className="text-center py-5">
          <p className="text-muted">No categories available.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-4" style={{ backgroundColor: "#f5f6fb" }}>
      {/* Header Section */}
      <div className="container-fluid px-3 px-md-4 mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex flex-column">
            <h2 className="fw-bold text-dark mb-2 fs-4">
              India's Most Affordable Home Salon
            </h2>
            <div
              className="bg-primary rounded"
              style={{ width: "50px", height: "3px" }}
            ></div>
          </div>
        </div>
      </div>

      {/* Desktop Version */}
      <div
        className="container-fluid px-0 d-none d-md-block"
        style={{ backgroundColor: "#f5f6fb" }}
      >
        <div className="px-3 px-md-4">
          <div className="row g-3">
            {menAndWomenCategory.map((category, index) => (
              <div
                key={`category-${category._id || index}`}
                className="col-auto"
              >
                <div
                  className="d-flex flex-column h-100 bg-white rounded-3 overflow-hidden"
                  onClick={() => navigationClick(category)}
                  style={{
                    cursor: "pointer",
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    width: "280px",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 1px 3px rgba(0,0,0,0.1)";
                  }}
                >
                  <div
                    className="position-relative overflow-hidden"
                    style={{ height: "180px", flex: "0 0 auto" }}
                  >
                    <img
                      src={category.desktopImage}
                      alt={category.name}
                      className="w-100 h-100 object-fit-cover"
                      onError={(e) => {
                        e.target.src =
                          "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect width='400' height='300' fill='%23f8f9fa'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='18' fill='%236c757d' text-anchor='middle' dy='.3em'%3ECategory Image%3C/text%3E%3C/svg%3E";
                      }}
                    />
                    <div
                      className="position-absolute top-0 start-0 w-100 h-100"
                      style={{
                        background:
                          "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.1) 100%)",
                      }}
                    ></div>
                  </div>
                  <div className="p-3 d-flex flex-column flex-grow-1">
                    <h6 className="fw-semibold mb-1 text-truncate fs-6 text-dark text-center">
                      {category.name}
                    </h6>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile Version */}
      <div
        className="container-fluid px-0 d-block d-md-none"
        style={{ backgroundColor: "#f5f6fb" }}
      >
        <div className="px-3">
          <div className="row g-2">
            {menAndWomenCategory.map((category, index) => (
              <div
                key={`category-mobile-${category._id || index}`}
                className="col-3"
              >
                <div
                  className="d-flex flex-column h-100 bg-white rounded-3 overflow-hidden"
                  onClick={() => navigationClick(category)}
                  style={{
                    cursor: "pointer",
                    transition: "transform 0.2s ease",
                  }}
                >
                  <div
                    className="position-relative overflow-hidden"
                    style={{ height: "60px", flex: "0 0 auto" }}
                  >
                    <img
                      src={category.desktopImage}
                      alt={category.name}
                      className="w-100 h-100 object-fit-cover"
                      onError={(e) => {
                        e.target.src =
                          "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect width='400' height='300' fill='%23f8f9fa'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='18' fill='%236c757d' text-anchor='middle' dy='.3em'%3ECategory Image%3C/text%3E%3C/svg%3E";
                      }}
                    />
                    <div
                      className="position-absolute top-0 start-0 w-100 h-100"
                      style={{
                        background:
                          "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.1) 100%)",
                      }}
                    ></div>
                  </div>
                  <div className="p-1 d-flex flex-column flex-grow-1 text-center">
                    <h6
                      className="fw-semibold mb-0 text-truncate"
                      style={{ fontSize: "10px", lineHeight: "1.2" }}
                    >
                      {category.name}
                    </h6>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryPage;